export const enum FilesUrlBase {
    diagnosticReports = 'diagnosticReports',
    procedures = 'procedures',
    processActivities = 'processActivities',
    requests = 'requests',
}
